import {District, ServerError,} from '../models/types';
import {useQuery} from "react-query";
import {retrieveDistricts} from "../restapi/geo";

export function useRetrieveDistricts({onError}: {onError?: (e: ServerError) => void}): District[] | undefined {
    const snacksQuery = useQuery(['districts'], () => retrieveDistricts(), {onError: onError});
    return snacksQuery.data;
}
